// .storybook/manager.js

import { addons } from "@storybook/addons";
import organicTheme from "./organicTheme";

addons.setConfig({
  theme: organicTheme,
});
